import { apiService } from '../main';
import { basicExcelExport, ExcelColFormats } from '../utils/excelExport';
import router from '../router';

class TisztaTiszaFunctions {
  BejegyzesSzures(bejelentes, regex, t) {
    let tests = [
      regex.test(t(bejelentes.Country)),
      regex.test(bejelentes.Locality),
      regex.test(t(bejelentes.Size)),
      regex.test(t(bejelentes.Status)),
      regex.test(bejelentes.Note),
      ...bejelentes.Types.map(m => regex.test(t(m))),
      ...bejelentes.Accessibility.map(m => regex.test(t(m))),
    ];
    return tests.some(s => s == true);
  }
  ExcelExportBejegyzesek(bejegyzesek, t) {
    let headers = [
      {
        header: t('ui_excelExportHeaderId'),
        key: 'Id',
        width: 10,
      },
      {
        header: t('ui_excelExportHeaderLatitude'),
        key: 'Latitude',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderLongitude'),
        key: 'Longitude',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderCountry'),
        key: 'Country',
        width: 20,
        renderFn: value => t(value),
      },

      {
        header: t('ui_excelExportHeaderLocality'),
        key: 'Locality',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderSubLocality'),
        key: 'SubLocality',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderTypes'),
        key: 'Types',
        width: 20,
        renderFn: value => value.map(s => t(s)).join(','),
      },
      {
        header: t('ui_excelExportHeaderUpdateTime'),
        key: 'UpdateTime',
        width: 20,
        dataStyle: ExcelColFormats.DateTime,
        renderFn: value => new Date(value),
      },
      {
        header: t('ui_excelExportHeaderUpdateNeeded'),
        key: 'UpdateNeeded',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderNote'),
        key: 'Note',
        width: 20,
        dataStyle: ExcelColFormats.String,
      },
      {
        header: t('ui_excelExportHeaderUrl'),
        key: 'Url',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderStatus'),
        key: 'Status',
        width: 20,
        renderFn: value => t(value),
      },
      {
        header: t('ui_excelExportHeaderSize'),
        key: 'Size',
        width: 20,
        renderFn: value => t(value),
      },
      {
        header: t('ui_excelExportHeaderAnonymous'),
        key: 'Anonymous',
        width: 20,
      },
      {
        header: t('ui_excelExportHeaderCreated'),
        key: 'Created',
        width: 20,
        dataStyle: ExcelColFormats.DateTime,
        renderFn: value => new Date(value),
      },
      {
        header: t('ui_excelExportHeaderAccessibility'),
        key: 'Accessibility',
        width: 20,
        renderFn: value => value.map(s => t(s)).join(','),
      },
      {
        header: t('ui_excelExportHeaderImage'),
        key: 'Image',
        width: 20,
      },
    ];

    basicExcelExport({
      title: t('ui_excelExportTitle'),
      headers: headers,
      rows: bejegyzesek,
    });
  }
  GetLocale() {
    console.log(router.currentRoute);
    return location.hash.slice(2, 4) || 'hu';
  }
}

let instance = new TisztaTiszaFunctions();
export { instance as TisztaTiszaFunctions };
